import React, { useState, useEffect } from 'react';
import { CardBody, CardFooter, ListGroup, ListGroupItem, Button, Card } from 'reactstrap';
import { Link, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { sortBy } from 'lodash';
import { CardHeader, PseudoStates } from '@cordata/buffet';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { authorizedPyInstance as axios, CardItemLimit } from '~/utils';

import ListGroupItemReminders from '~/components/Reminder/ListGroupItem';

const CardReminders = ({ className }) => {
  const params = useParams();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState();

  const [didSaveReminder, setDidSaveReminder] = useState(false);

  const loadReminders = () =>
    axios.get(`/api/data/public/patient/${params.patient_id}/notifications`, {
      params: {
        is_read: false,
      },
    })
      .then(r => r.data.data)
      .then(r => setData(r))
      .catch(e => setError(e))
      .then(() => setIsLoading(false));

  useEffect(() => {
    loadReminders();
  }, []);

  useEffect(() => {
    if (didSaveReminder) {
      setDidSaveReminder(false);

      loadReminders();
    }
  }, [didSaveReminder]);

  return (
    <Card className={classnames(className)}>
      <CardHeader
        className="text-light"
        color="primary"
        action={
          <Button
            outline
            color="light"
            tag={Link}
            to={`/patients/${params.patient_id}/reminders/add`}
            size="sm"
          >
            <FontAwesomeIcon icon="plus" />
          </Button>
        }
      >
        Reminders
      </CardHeader>

      <CardBody className="p-0">
        {!isLoading && !error ? (
          <ListGroup flush>
            {sortBy(data, ['attributes.reminderDate']).reverse().slice(0, CardItemLimit).map(d => (
              <ListGroupItemReminders
                key={d.id}
                data={d}
                setDidSaveReminder={setDidSaveReminder}
              />
            ))}

            {!data.length && (
              <ListGroupItem>
                No Reminders
              </ListGroupItem>
            )}
          </ListGroup>
        ) : (
          <PseudoStates isLoading={isLoading} error={error} />
        )}
      </CardBody>

      <CardFooter
        tag={Link}
        to={`/patients/${params.patient_id}/reminders`}
        className="text-center"
      >
        Show More ...
      </CardFooter>
    </Card>
  );
};

CardReminders.propTypes = {
  className: PropTypes.string,
};

CardReminders.defaultProps = {
  className: undefined,
};

export default CardReminders;
